import { Component, Input, Output, EventEmitter, ViewChild, ViewChildren } from '@angular/core';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { Platform } from 'ionic-angular/platform/platform';
import { Events } from 'ionic-angular';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoReserveTimelineComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-timeline',
  templateUrl: 'co-reserve-timeline.html',
  inputs: ['roomDetails', 'currentDay', 'isCostEnabled', 'isRoomBookable', 'bookingTimeRangeAllowed', 'roomLocation', 'currentCart']
})
export class CoReserveTimelineComponent {
  @Input('roomDetails') roomDetails;
  @Input('currentDay') currentDay;
  @Input('isCostEnabled') isCostEnabled;
  @Input('isRoomBookable') isRoomBookable;
  @Input('bookingTimeRangeAllowed') bookingTimeRangeAllowed;
  @Input('roomLocation') roomLocation;
  @Input('currentCart') currentCart;
  weekHours: any;
  pageTimeline: any;
  firstSelected: any;
  secondSelected: any;
  timelineStepIntervalSetting: number;
  timelineScrollBar: number; //change to change starting position of scroll
  currentDayReservations: any;
  timezoneOffset: any;
  timelineLabels: any = [];
  timelineBoxInterval: number = 15; //time each block represents
  timelineBoxSegments: number = 1; //intervals customers have to book in, if 2 and 15 minute intervls - reservation length cant be 15 or 45 minutes
  allTimeBlocks: any;
  selectedBlocks: any;
  setupBlocks: any;
  reserveStartTime: any;
  reserveEndTime: any;
  timelineScrollbarMax: number= 100;
  pageHours: any = {};
  reservationLength: string;
  reservationLengthHour: any = 1;
  reservationLengthMinutes: any;
  roomBookingCost: any;
  hideScroller = true;
  timeConflict: boolean = false;
  selectedLayout: any;
  statusMessage: string = "";
  locationPhoneNumber: string;
  clientInfo: any;
  locationClosed: boolean = false;
  @Output() onTimePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onConflictUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAssetUpdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('reserveTimelineDetailsPage') reserveTimelineDetailsPage;
  @ViewChild('scrolly') scrolly;
  @ViewChildren('setupTime') setupTimeArray;
  rooms_adjust_setup: boolean = true;
  timelineBoxContainer: any;

  constructor(public locationsProvider: LocationsProvider, public reserveProvider: ReserveProvider, public clientDetails: ClientDetailsProvider, public platform: Platform, private events: Events, private _appState: AppState) {
  }

  ngOnInit() {
    this.clientDetails.load().then((res) => {
      this.timezoneOffset = res.timezone[0].offset;
      this.clientInfo = res.settings;
      this.timelineBoxInterval = this.roomDetails.segmentSizeInMinutes;
      this.timelineBoxSegments = this.roomDetails.segmentsPerBlock;
      this.initializeTimeline();
    });
    this.events.subscribe('horizontalScrollUpdated', (newValue) => {
      this.timelineScrollBar = newValue;
    })
  }

  initializeTimeline() {
    this.getLocationHours(this.roomDetails.locationId, this.currentDay);
  }

  onChange(event?) {
    // let boxList= this.timelineContainer.nativeElement.getElementsByClassName('timeblock');
    if (!this.timelineBoxContainer) {
      this.timelineBoxContainer = event._elementRef.nativeElement.parentElement.children[0];
      this.timelineBoxContainer = this.reserveTimelineDetailsPage.nativeElement;
    }
    // let boxContainer = event._elementRef.nativeElement.parentElement.children[0]; replaced by timelineBoxContainer
    // let boxArray: any = Array.from(boxList);
    // let boxWidth = boxArray[0].getBoundingClientRect().width;
    let scrollyWidth = this.scrolly.nativeElement.getBoundingClientRect().width;
    let boxContainerWidth = this.timelineBoxContainer.getBoundingClientRect().width;
    this.timelineScrollbarMax = scrollyWidth-boxContainerWidth;
    this.timelineBoxContainer.scrollLeft = this.timelineScrollBar;
    // this.timelineScrollbarMax = ((boxContainerWidth - Math.min(this.platform.width(), 710)) / boxWidth)+1;
    // boxContainer.scrollLeft = (boxWidth) * this.timelineScrollBar;
    // this.timelineBoxContainer.scrollLeft = (scrollyWidth - boxContainerWidth) * (this.timelineScrollBar/this.timelineScrollbarMax);
  }

  async buildArray() {
    this.pageTimeline = [];
    this.timelineLabels = [];
    let locationTime: { start: any, end: any } = { start: '', end: '' }
    let startTime = [this.weekHours[moment(this.currentDay).day()].start.split(':')[0], this.weekHours[moment(this.currentDay).day()].start.split(':')[1].split(' ')[0]];
    let endTime = [this.weekHours[moment(this.currentDay).day()].end.split(':')[0], this.weekHours[moment(this.currentDay).day()].end.split(':')[1].split(' ')[0]];

    locationTime.start = moment(this.currentDay).hour(Number(startTime[0])).minute(Number(startTime[1])).startOf('minute');
    locationTime.end = moment(this.currentDay).hour(Number(endTime[0])).minute(Number(endTime[1])).startOf('minute');

    //below variables used in other functions
    this.pageHours.startHour = locationTime.start.hour();
    this.pageHours.startMinute = locationTime.start.minute();

    this.locationClosed = false;
    let segments;
    try {
      // console.log(locationTime.end.diff(locationTime.start, 'minutes'), this.timelineBoxInterval)
      segments = new Array(Math.ceil((locationTime.end.diff(locationTime.start, 'minutes')) / this.timelineBoxInterval));
    } catch (ex) {
      // console.log(this.location);
      segments = [];
      this.locationClosed = true;
    }

    //apply buffer
    const locationTimeStartWithoutBuffer = locationTime.start.clone();
    const locationTimeEndWithoutBuffer = locationTime.end.clone();
    locationTime.start.add(this.roomDetails.dayStartBuffer, 'minutes');
    locationTime.end.subtract(this.roomDetails.dayEndBuffer, 'minutes');

    let outputArray = [];
    let currentTimeOfDay = moment(this.currentDay).startOf('hour').hour(Number(startTime[0])).minute(Number(startTime[1]));

    if ((locationTime.start).isSame(locationTime.end)) {
      for (let j = 0; j < segments.length; j++) {
        //if location closed for day
        outputArray.push(false);
        if (currentTimeOfDay.minutes() === 0) {
          this.timelineLabels.push(currentTimeOfDay.format("H:mm").toString());
        }
        else {
          this.timelineLabels.push("");
        }
        currentTimeOfDay = currentTimeOfDay.add(this.timelineBoxInterval, 'minutes');
      };
      this.locationClosed = true;
      this.timeConflict = true;
      this.statusMessage = `Closed today`;
      this.reserveStartTime = moment(this.currentDay).startOf('day');
    } else {
      for (let i = 0; i < segments.length; i++) {
        //define object for array
        let reservationBlock: { bookable: boolean, alreadyInCart: boolean, isBuffer: boolean } = {bookable: true, alreadyInCart: false, isBuffer: false};
        reservationBlock.bookable = true;
        reservationBlock.alreadyInCart = false;
        let currentCart = this.currentCart;
        this.events.subscribe("itemRemovedFromCart", (cart) => {
          currentCart = cart;
        })
        if (currentCart.length > 0) {
          currentCart.forEach(booking => {
            if (currentTimeOfDay.isBetween(moment(booking.reserveStartTime).subtract(1, 'minute'), moment(booking.reserveEndTime)) && booking.room.id === this.roomDetails.id) {
              reservationBlock.bookable = false;
              reservationBlock.alreadyInCart = true;
            }
          });
        }

        //if location not open yet/is closed or currentTimeOfDay is before current time of today's time
        if(
          (currentTimeOfDay.isSameOrAfter(locationTimeStartWithoutBuffer) &&  currentTimeOfDay.isBefore(locationTime.start)) ||
          (currentTimeOfDay.isBefore(locationTimeEndWithoutBuffer) && currentTimeOfDay.isSameOrAfter(locationTime.end))
        ) {
          reservationBlock.bookable = false;
          reservationBlock.isBuffer = true;
          // reservationBlock.alreadyInCart = false;
          outputArray.push(reservationBlock);
        } else if (
          currentTimeOfDay.isBefore(locationTime.start) ||
          currentTimeOfDay.isSameOrAfter(locationTime.end) ||
          moment(currentTimeOfDay).isSameOrBefore(moment().startOf('minute'))
        ) {
          reservationBlock.bookable = false;
          // reservationBlock.alreadyInCart = false;
          outputArray.push(reservationBlock);
        } else {
          //if reservations exist
          if (this.currentDayReservations.length > 0) {
            let alreadyChecked = false;
            this.currentDayReservations.forEach(reservation => {
              if (currentTimeOfDay.isBetween(moment(reservation.startTime).startOf('minute'), moment(reservation.endTime).endOf('minute').subtract(1, 'minute')) || currentTimeOfDay.isSame(moment(reservation.startTime).startOf('minute'))) {
                if (!alreadyChecked) {
                  alreadyChecked = true;
                  reservationBlock.bookable = false;
                  // reservationBlock.alreadyInCart = false;
                  outputArray.push(reservationBlock); //if between a reservation start / end time
                }
              }
            });
            if (!alreadyChecked) {
              alreadyChecked = true;
              reservationBlock.bookable = true;
              // reservationBlock.alreadyInCart = false;
              outputArray.push(reservationBlock); //if not between a reservation start / end time
            }
          }
          //if no reservations
          else {
            reservationBlock.bookable = true;
            // reservationBlock.alreadyInCart = false;
            outputArray.push(reservationBlock);
          }
        };

        if (currentTimeOfDay.minutes() === 0) {
          this.timelineLabels.push(currentTimeOfDay.toString());
        }
        else {
          this.timelineLabels.push("");
        }
        currentTimeOfDay = currentTimeOfDay.add(this.timelineBoxInterval, 'minutes');
      };
    }

    this.pageTimeline = outputArray;
    return;
  }

  getLocationHours(location, day) {
    let roomId = this.roomDetails.id;
    this.locationsProvider.getRoomWeekHours(location, roomId, day, true).then((res) => {
      this.weekHours = res;
      this.getRoomReservations(this.roomDetails.id);
    });
    this.locationsProvider.getLocation(location).then((res) => {
      this.locationPhoneNumber = res.phone;
    })
  };

  getRoomReservations(roomId) {
    let self = this;
    let startDate, endDate;
    startDate = moment(this.currentDay).startOf('day').format("YYYY-MM-DD HH:mm:ss");
    endDate = moment(this.currentDay).endOf('day').format("YYYY-MM-DD HH:mm:ss");
    this.reserveProvider.getReservations(startDate, endDate, roomId).then((res) => {
      this.currentDayReservations = res.filter(reservation => {
        return (reservation.status !== 'cancelled' && reservation.status !== 'declined' && [0, 2].includes(reservation.noShow));
      });
      this.buildArray().then(() => {
        setTimeout(() => {
          //hide scroll bar if too small
          let boxContainer = this.reserveTimelineDetailsPage.nativeElement;
          let scrolly = this.scrolly.nativeElement;
          if (scrolly.clientWidth > boxContainer.clientWidth) {
            self.hideScroller = false;
          }
        }, 0);

      });
    });
  }

  async selectTime(event, i) {
    let parentElement = event.target.parentElement.parentElement;
    let timeBlockElement = event.target;

    //if first click
    if (!this.firstSelected && !this.secondSelected) {
      this.firstSelected = timeBlockElement;
      this.secondSelected = timeBlockElement;
      this.allTimeBlocks = parentElement.getElementsByClassName("timeblock");
      this.allTimeBlocks = Array.from(this.allTimeBlocks);
    }

    //clear timeline
    await this.resetClasses();

    //if clicked passed the end time
    if (this.secondSelected.getAttribute('value') < i) {
      this.secondSelected = timeBlockElement;
    }
    //if clicked before the first time
    else if (this.firstSelected.getAttribute('value') > i) {
      this.firstSelected = timeBlockElement;
    }
    //if clicked between, reset first and second
    else {
      this.firstSelected = timeBlockElement;
      this.secondSelected = timeBlockElement;
    }
    //redraw all between first and second selected
    for (let j = Number(this.firstSelected.getAttribute('value')); j <= Number(this.secondSelected.getAttribute('value')); j++) {
      if (!this.allTimeBlocks[j].classList.contains("selectedTimeBlock")) {
        this.allTimeBlocks[j].classList.add("selectedTimeBlock");
      }
    }

    //Add class to setup/breakdown time blocks
    // this.allTimeBlocks[breakdownTimeIndex].classList.add("setupTime");

    //Set Times from blocks
    // this.setTimes(setupTimeIndex, breakdownTimeIndex);

    this.applySetupBreakdownTime();

    //turn necessary blocks red
    this.checkForConflicts();

  }

  applySetupBreakdownTime() {
    let parentElement;
    if (!this.allTimeBlocks) {
      return;
      // parentElement = this.timelineContainer.nativeElement;
    } else {
      parentElement = this.allTimeBlocks[0].parentElement.parentElement;
    }

    if (!this.firstSelected || !this.secondSelected) {
      return;
    }

    let allSetupBlocks = parentElement.querySelectorAll(".setupTime");

    if (allSetupBlocks.length > 0) {
      allSetupBlocks.forEach(element => {
        element.classList.remove('setupTime');
      });
    }

    //Setup Time
    let setupTimeIndex = Number(this.firstSelected.getAttribute("value"));
    // console.log(this.clientInfo);
    if (setupTimeIndex >= 0 && !this.clientInfo.rooms_adjust_setup) {
      // if (setupTimeIndex === 0){
        // setupTimeIndex = 1;
      // }
      if (this.selectedLayout) {
        let setupTimeInterval: number = Math.ceil(this.selectedLayout.setupTime / this.timelineBoxInterval);

        for (let i = 0; i < setupTimeInterval; i++) {
          if (setupTimeIndex !== 0) {
            setupTimeIndex--;
          }
          this.allTimeBlocks[setupTimeIndex].classList.add("setupTime");
        }
      }
      else {
        let setupTimeInterval: number = Math.ceil(this.roomDetails.setupTime / this.timelineBoxInterval);

        for (let i = 0; i < setupTimeInterval; i++) {
          if (setupTimeIndex !== 0) {
            setupTimeIndex--;
          }
          this.allTimeBlocks[setupTimeIndex].classList.add("setupTime");
        }
      }
    } else {
      if (this.selectedLayout) {
        let setupTimeInterval: number = Math.ceil(this.selectedLayout.setupTime / this.timelineBoxInterval);

        for (let i = 0; i < setupTimeInterval; i++) {
          setupTimeIndex--;
          if (setupTimeIndex >= 0) {
            this.allTimeBlocks[setupTimeIndex].classList.add("setupTime");
          }
        }
      }
      else {
        let setupTimeInterval: number = Math.ceil(this.roomDetails.setupTime / this.timelineBoxInterval);

        for (let i = 0; i < setupTimeInterval; i++) {
          setupTimeIndex--;
          if (setupTimeIndex >= 0) {
            this.allTimeBlocks[setupTimeIndex].classList.add("setupTime");
          }
        }
      }
    }

    //Breakdown Time
    let breakdownTimeIndex = Number(this.secondSelected.getAttribute("value"));
    // console.log(this.clientInfo.rooms_adjust_setup)
    if (breakdownTimeIndex <= this.allTimeBlocks.length - 1 && !this.clientInfo.rooms_adjust_setup) {
      if (breakdownTimeIndex === this.allTimeBlocks.length - 1) {
        breakdownTimeIndex = this.allTimeBlocks.length - 1;
      }
      if (this.selectedLayout) {
        let breakdownTimeInterval: number = Math.ceil(this.selectedLayout.breakdownTime / this.timelineBoxInterval);
        for (let i = 0; i < breakdownTimeInterval; i++) {
          if (breakdownTimeIndex < this.allTimeBlocks.length -1) {
            breakdownTimeIndex++;
          }
          this.allTimeBlocks[breakdownTimeIndex].classList.add("setupTime");
        }
      }
      else {
        let breakdownTimeInterval: number = Math.ceil(this.roomDetails.breakdownTime / this.timelineBoxInterval);

        for (let i = 0; i < breakdownTimeInterval; i++) {
          if (breakdownTimeIndex < this.allTimeBlocks.length -1) {
            breakdownTimeIndex++;
          }
          this.allTimeBlocks[breakdownTimeIndex].classList.add("setupTime");
        }
      }
    } else {
      if (breakdownTimeIndex === this.allTimeBlocks.length - 1) {
        breakdownTimeIndex = this.allTimeBlocks.length - 1;
      }
      if (this.selectedLayout) {
        let breakdownTimeInterval: number = Math.ceil(this.selectedLayout.breakdownTime / this.timelineBoxInterval);
        for (let i = 0; i < breakdownTimeInterval; i++) {
          breakdownTimeIndex++;
          if (breakdownTimeIndex <= this.allTimeBlocks.length -1) {
            this.allTimeBlocks[breakdownTimeIndex].classList.add("setupTime");
          }
        }
      }
      else {
        let breakdownTimeInterval: number = Math.ceil(this.roomDetails.breakdownTime / this.timelineBoxInterval);

        for (let i = 0; i < breakdownTimeInterval; i++) {
          breakdownTimeIndex++;
          if (breakdownTimeIndex <= this.allTimeBlocks.length -1) {
            this.allTimeBlocks[breakdownTimeIndex].classList.add("setupTime");
          }
        }
      }
    }

    allSetupBlocks = parentElement.querySelectorAll(".setupTime");
    this.setupBlocks = Array.from(allSetupBlocks);

    this.setTimes(setupTimeIndex, breakdownTimeIndex);
  }

  setTimes(firstBlockIndex, secondBlockIndex) {
    let startMinutes, endMinutes;
    let self = this;
    startMinutes = firstBlockIndex * this.timelineBoxInterval; //gets the current interval that the blocks are displayed and multiplies by index
    endMinutes = (secondBlockIndex * this.timelineBoxInterval) + this.timelineBoxInterval; //gets the END index of the breakdown block and multiplies by interval

    // console.log(firstBlockIndex, secondBlockIndex, this.timelineBoxInterval);
    let startOfDay = moment(this.currentDay).startOf('hour').hour(this.pageHours.startHour).minute(this.pageHours.startMinute);

    let setupTimeMinutes = 0;
    let breakdownTimeMinutes = 0;

    if(this.selectedLayout && this.selectedLayout.setupTime) {
      setupTimeMinutes = Math.ceil(this.selectedLayout.setupTime / this.timelineBoxInterval) * this.timelineBoxInterval;
    } else {
      setupTimeMinutes = Math.ceil(this.roomDetails.setupTime / this.timelineBoxInterval) * this.timelineBoxInterval;
    }
    if(this.selectedLayout && this.selectedLayout.breakdownTime) {
      breakdownTimeMinutes = Math.ceil(this.selectedLayout.breakdownTime / this.timelineBoxInterval) * this.timelineBoxInterval;
    } else {
      breakdownTimeMinutes = Math.ceil(this.roomDetails.breakdownTime / this.timelineBoxInterval) * this.timelineBoxInterval;
    }

    this.reserveStartTime = moment(startOfDay).add(startMinutes, 'minutes').add(setupTimeMinutes, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    this.reserveEndTime = moment(startOfDay).add(endMinutes, 'minutes').subtract(breakdownTimeMinutes, 'minutes').format("YYYY-MM-DD HH:mm:ss");

    let timeArray = [this.reserveStartTime, this.reserveEndTime];
    this.buildReservationLengthString(this.reserveStartTime, this.reserveEndTime);
    this.calculateCost();
    this.reserveProvider.getAvailableAssets(this.roomDetails.id, this.reserveStartTime, this.reserveEndTime).then((res) => {
      self.onAssetUpdate.emit(res);
    });
    //update parent page's time
    this.onTimePicked.emit(timeArray);
  }

  calculateCost() {
    let cost = 0;
    if (this.roomDetails.roomChargePeriod === 'Per block') {
      let bookingTimeChargePeriod = this.roomDetails.segmentsPerBlock * this.roomDetails.segmentSizeInMinutes;
      let multiplierToCharge = this.reservationLengthMinutes / bookingTimeChargePeriod;
      cost = this.roomDetails.roomCharge * multiplierToCharge;
    }
    else {
      cost = this.roomDetails.roomCharge;
    }

    this.roomBookingCost = cost;
  }

  checkForConflicts() {
    let isConflict: boolean = false;

    if (this.allTimeBlocks !== [] && this.allTimeBlocks !== undefined) {
      let parentElement = this.allTimeBlocks[0].parentElement.parentElement;
      this.selectedBlocks = parentElement.getElementsByClassName("selectedTimeBlock");
      this.selectedBlocks = Array.from(this.selectedBlocks);

      this.setupBlocks = parentElement.getElementsByClassName("setupTime");
      this.setupBlocks = Array.from(this.setupBlocks);

      if (this.selectedBlocks.length % this.timelineBoxSegments !== 0) {
        this.statusMessage = `This room can only be booked in increments of ${this.timelineBoxSegments * this.timelineBoxInterval} minutes`;
        isConflict = true;
      }
    }


    if (!this.selectedLayout && this.roomDetails.layouts.length > 0) {
      this.statusMessage = "A layout is required for this room.";
      isConflict = true;
    }

    if (this.roomDetails.bookingLimits.minimumBookingInMinutes > 0) {
      let time = this.roomDetails.bookingLimits.minimumBookingInMinutes;
      if (this.reservationLengthMinutes < this.roomDetails.bookingLimits.minimumBookingInMinutes) {
        isConflict = true;
        let hour, minute;
        hour = Math.floor(time / 60);
        // if (hour === 0) {
        //   hour = 1;
        //   resetHour = true;
        // }
        if (hour === 0) {
          minute = time;
        } else {
          minute = time - (60 * hour);
        }
        // if (resetHour) {
        //   hour = 0;
        //   resetHour = false;
        // }
        let finalString: string = "";

        if (hour === 1) {
          finalString = "1 hour";
        }
        else if (hour > 1) {
          finalString = `${hour} hours`;
        }

        if (minute === 1) {
          if (finalString === "") {
            finalString = "1 minute";
          }
          else {
            finalString += " 1 minute";
          }
        }
        else if (minute > 1) {
          if (finalString === "") {
            finalString = `${minute} minutes`;
          }
          else {
            finalString += ` ${minute} minutes`;
          }
        }
        this.statusMessage = `This room must be booked for at least ${finalString}`;
      }
    }

    if (this.roomDetails.bookingLimits.maximumBookingInMinutes > 0) {
      if (this.reservationLengthMinutes > this.roomDetails.bookingLimits.maximumBookingInMinutes) {
        isConflict = true;
        let time = this.roomDetails.bookingLimits.maximumBookingInMinutes;
        let hour, minute;
        hour = Math.floor(time / 60);
        if (hour === 0) {
          hour = 1;
        }
        minute = time - (60 * hour);

        let finalString: string = "";

        if (hour === 1) {
          finalString = "1 hour";
        }
        else if (hour > 1) {
          finalString = `${hour} hours`;
        }

        if (minute === 1) {
          if (finalString === "") {
            finalString = "1 minute";
          }
          else {
            finalString += " 1 minute";
          }
        }
        else if (minute > 1) {
          if (finalString === "") {
            finalString = `${minute} minutes`;
          }
          else {
            finalString += ` ${minute} minutes`;
          }
        }

        this.statusMessage = `This room cannot be booked for more than ${finalString}`;
      }
    }

    if (this.selectedBlocks && this.selectedBlocks.length > 0) {
      this.selectedBlocks.forEach(element => {
        if (element.classList.contains("notBookableBlock")) {
          element.classList.add("conflictBlock");
          this.statusMessage = "There is a clash with an existing booking.";
          isConflict = true;
        }
      });
    }

    if (this.selectedBlocks && this.setupBlocks.length > 0) {
      this.setupBlocks.forEach(element => {
        if (element.classList.contains("notBookableBlock") && !element.classList.contains("bufferBlock")) {
          element.classList.add("conflictBlock");
          this.statusMessage = "There is a clash with an existing booking.";
          isConflict = true;
        }
      });
    }

    if (!this.bookingTimeRangeAllowed.nearest) {
      isConflict = true;
      this.statusMessage = `This room must be booked at least ${this.roomDetails.bookingLimits.nearestBookingInDays} days in advance.`
    }

    if (!this.bookingTimeRangeAllowed.furthest) {
      isConflict = true;
      if (this.roomDetails.bookingLimits.furthestBookingInDays !== 0) {
        this.statusMessage = `This room cannot be booked more than ${this.roomDetails.bookingLimits.furthestBookingInDays} days in advance.`
      } else {
        this.statusMessage = 'This room can only be booked for today.';
      }
    }

    if (!this.isRoomBookable && !this._appState.staff) {
      isConflict = true;
      this.statusMessage = "This room cannot be booked online please call the branch at " + this.locationPhoneNumber;
    }

    this.timeConflict = isConflict;
    this.onConflictUpdate.emit(this.timeConflict);
  }

  resetClasses() {
    let parentElement = this.scrolly.nativeElement;
    // if (!this.allTimeBlocks) {
    //   console.log('ran 1')
      // parentElement = this.timelineContainer.nativeElement;
    // } else {
    //   console.log(this.allTimeBlocks);;
    //   parentElement = this.allTimeBlocks[0].parentElement.parentElement;
    // }
    //remove class from all

    let selectedBlocks = Array.from(parentElement.getElementsByClassName("selectedTimeBlock"));
    let conflictBlocks = Array.from(parentElement.getElementsByClassName("conflictBlock"));
    let setupBlocks = Array.from(parentElement.getElementsByClassName("setupTime"));

    // selectedBlocks = Array.from(selectedBlocks);
    // conflictBlocks = Array.from(conflictBlocks);
    // setupBlocks = Array.from(setupBlocks);

    selectedBlocks.forEach(element => {
      let e : any = element;
      e.classList.remove("selectedTimeBlock");
    });

    conflictBlocks.forEach(element => {
      let e : any = element;
      e.classList.remove("conflictBlock");
    });

    setupBlocks.forEach(element => {
      let e : any = element;
      e.classList.remove("setupTime");
    });
  }

  resetTimeline() {
    let self = this;
    this.events.publish('itemRemovedFromCart', this.currentCart);
    this.buildArray().then(() => {
      setTimeout(() => {
        //hide scroll bar if too small
        let boxContainer = this.reserveTimelineDetailsPage.nativeElement;
        let scrolly = this.scrolly.nativeElement;
        if (scrolly.clientWidth > boxContainer.clientWidth) {
          self.hideScroller = false;
        }
      }, 0);

    });
    this.resetClasses();
    this.firstSelected = undefined;
    this.secondSelected = undefined;
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.reservationLengthHour = undefined;
    let timeArray = [this.reserveStartTime, this.reserveEndTime, 'closed'];
    this.onTimePicked.emit(timeArray);
  }

  buildReservationLengthString(startTime, endTime) {
    let hour, minute;
    this.reservationLengthMinutes = moment(endTime).diff(startTime, "minutes");
    hour = moment(endTime).diff(startTime, "hours");
    minute = moment(endTime).diff(startTime, "minutes");
    if (hour > 0) {
      minute = minute - (hour * 60);
    }

    let finalString: string = "";

    if (hour === 1) {
      finalString = "1 hour";
    }
    else if (hour > 1) {
      finalString = `${hour} hours`;
    }

    if (minute === 1) {
      if (finalString === "") {
        finalString = "1 minute";
      }
      else {
        finalString += " 1 minute";
      }
    }
    else if (minute > 1) {
      if (finalString === "") {
        finalString = `${minute} minutes`;
      }
      else {
        finalString += ` ${minute} minutes`;
      }
    }
    this.reservationLengthHour = hour;

    if (hour === 0) {
      this.reservationLengthHour = 1;
    }

    // if (finalString === "" && this.reserveStartTime) {
    //   finalString = this.timelineBoxInterval.toString() + " minutes";
    // }
    this.reservationLength = finalString;
  }
}


// WEBPACK FOOTER //
// ./src/components/co-reserve-timeline/co-reserve-timeline.ts